import { IEnvironmentConfiguration } from './environment';

export const environmentConfiguration: IEnvironmentConfiguration = {
	apiBasePath: 'https://pilotpay-test-api.activeaero.com',
	isProduction: false,
	frontendIdentityUrl: 'https://identity-service-ui-dev.peakplatform.io',
	backendIdentityUrl: 'https://identity-service-api-dev.peakplatform.io',
	allowedEmailDomains: ['ascentgl.net']
};
